import {Sale} from './Sale';
import {Price} from './Price';
import {Header} from './Header';
import {Button} from './Button';
import {Footer} from './Footer';
import {Loader} from './Loader';
import {Rating} from './Rating';
import {Select} from './Select';
import {Container} from './Container';
import {ServiceGrid} from './ServiceGrid';
import {HeroSlider} from './HeroSlider';
import {StarRating} from './StarRating';
import {RatingStars} from './RatingStars';
import {OrderStatus} from './OrderStatus';
import {QuickContact} from './QuickContact';
import {BlockHeading} from './BlockHeading';
import {PwaInstallButton} from './PwaInstallButton';
import {PwaInstallPrompt} from './PwaInstallPrompt';

export const components = {
  Sale,
  Price,
  Header,
  Button,
  Loader,
  Footer,
  Rating,
  Select,
  Container,
  ServiceGrid,
  HeroSlider,
  QuickContact,
  PwaInstallButton,
  PwaInstallPrompt,
  StarRating,
  OrderStatus,
  RatingStars,
  BlockHeading,
};
